import servicesRoutes from "@/router/servicesRoutes";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";
import istanzeRoutes from "@/router/istanzeRoutes";
import userRoutes from "@/router/userRoutes";
import viewerRoutes from "@/router/viewerRoutes";

const Home = () => import('@/views/Home.vue')

const homeRoutes = [
    {
        path: '',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true,
            breadcrumb: {
                exclude: true
            } as IBreadcrumbMeta,
        },
    },
] as any [];

const defaultRoute = [
    {
        path: "/:catchAll(.*)",
        redirect: '/'
    }
]

export default homeRoutes.concat(servicesRoutes, istanzeRoutes, userRoutes, viewerRoutes, defaultRoute);
